import { EnumComponentType } from '../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { MDAConstant } from './Base/MDAConstant';

/** 设计器的扩展服务 */
export class DesignerExtendService {
  // BE组件能创建的类型和关系
  private static beShapes = [
    MDAConstant.Type.ADD_BUSINESSLOGIC,
    MDAConstant.Type.ADD_BECOMMENT,
    MDAConstant.Type.ADD_CONSTANT,
    MDAConstant.Type.ADD_DISTRIBUTEDTRANSACTION,
    MDAConstant.Type.ADD_DTO,
    MDAConstant.Type.ADD_ENTITY,
    MDAConstant.Type.ADD_ENUM,
    MDAConstant.Type.ADD_EXTERNALSERVICE,
    MDAConstant.Type.ADD_INTERFACE,
    MDAConstant.Type.ADD_REFERENCEENTITY,
    MDAConstant.Type.ADD_SERVICE,
    MDAConstant.Type.ADD_VALUEOBJECT,
    MDAConstant.Link.ADD_AGGREGATION,
    MDAConstant.Link.ADD_ASSOCIATION,
    MDAConstant.Link.ADD_COMPOSITION,
    MDAConstant.Link.ADD_CROSS,
    MDAConstant.Link.ADD_DEPENDENCY,
    MDAConstant.Link.ADD_GENERALIZATION,
    MDAConstant.Link.ADD_IMPLEMENT
  ];

  // APP组件能创建的类型和关系
  private static appShapes = [
    MDAConstant.Type.ADD_APPCOMMENT,
    MDAConstant.Type.ADD_CONFIGGROUP,
    MDAConstant.Type.ADD_MENUSET,
    MDAConstant.Link.ADD_MENUCONTAIN,
    MDAConstant.Link.ADD_TASKSEQUENCE
  ];

  // DB组件能创建的类型和关系
  private static dbShapes: string[] = [];

  // 产品组件能创建的类型和关系
  private static productShapes: string[] = [
    MDAConstant.Type.ADD_PRODUCTCOMMENT,
    MDAConstant.Type.ADD_PRODUCTAPP
  ];

  /**
   * 检查图形是否能在相应的组件类型中创建
   * @param componentType 组件类型
   * @param shapeType 图形类型，使用MDAConstant
   */
  public static checkShapeAllowed(componentType: EnumComponentType, shapeType: string): boolean {
    let result = false;
    switch (componentType) {
      case EnumComponentType.BE:
        result = this.beShapes.indexOf(shapeType) > -1;
        break;
      case EnumComponentType.APP:
        result = this.appShapes.indexOf(shapeType) > -1;
        break;
      case EnumComponentType.Product:
        result = this.productShapes.indexOf(shapeType) > -1;
        break;
      case EnumComponentType.DB:
      default:
        break;
    }
    return result;
  }

  /**
   * 获取类型图标
   * @param type 类型名称，使用MDAConstant里面的类型常量
   */
  public static getTypeIcon(type: string) {
    let icon = '/imgs/icons/';
    switch (type) {
      case MDAConstant.Type.ADD_APP:
        // 应用
        icon += 'icon_app.bmp';
        break;
      case MDAConstant.Type.ADD_PRODUCTCOMPONENT:
        // 产品组件
        icon += 'icon_productcomponent.bmp';
        break;
      case MDAConstant.Type.ADD_APPCOMPONENT:
        // 应用组件
        icon += 'icon_appcomponent.bmp';
        break;
      case MDAConstant.Type.ADD_DBCOMPONENT:
        // 数据库组件
        icon += 'icon_dbcomponent.bmp';
        break;
      case MDAConstant.Type.ADD_BECOMPONENT:
        // 业务组件
        icon += 'icon_becomponent.bmp';
        break;
      case MDAConstant.Type.ADD_UIMODELCOMPONENT:
        // 界面模型组件
        icon += 'icon_uimodelcomponent.bmp';
        break;
      case MDAConstant.Type.ADD_APPCOMMENT:
      case MDAConstant.Type.ADD_BECOMMENT:
      case MDAConstant.Type.ADD_PRODUCTCOMMENT:
        // 注释
        icon += 'CommentTool.png';
        break;
      case MDAConstant.Type.ADD_BUSINESSLOGIC:
        // 业务逻辑
        icon += 'icon_BusinessLogic.png';
        break;
      case MDAConstant.Type.ADD_CONFIGGROUP:
        // 配置组
        icon += 'icon_ConfigGroup.png';
        break;
      case MDAConstant.Type.ADD_CONSTANT:
        // 常量
        icon += 'icon_Constant.png';
        break;
      case MDAConstant.Type.ADD_DISTRIBUTEDTRANSACTION:
        // 分布式事务
        icon += 'icon_DistributedTransaction.png';
        break;
      case MDAConstant.Type.ADD_DTO:
        // 数据传输对象
        icon += 'icon_DTO.png';
        break;
      case MDAConstant.Type.ADD_ENTITY:
        // 实体
        icon += 'icon_Class.png';
        break;
      case MDAConstant.Type.ADD_ENUM:
        // 枚举
        icon += 'icon_Enum.png';
        break;
      case MDAConstant.Type.ADD_EXTERNALSERVICE:
        // 扩展服务
        icon += 'icon_ExternalService.png';
        break;
      case MDAConstant.Type.ADD_INTERFACE:
        // 接口
        icon += 'icon_Interface.png';
        break;
      case MDAConstant.Type.ADD_MENUSET:
        // 菜单集
        icon += 'icon_MenuSet.png';
        break;
      case MDAConstant.Type.ADD_METHOD:
        // 方法
        icon += ''; // TODO
        break;
      case MDAConstant.Type.ADD_PRODUCT:
        // 产品
        icon += ''; // TODO
        break;
      case MDAConstant.Type.ADD_PRODUCTAPP:
        // 产品关联应用
        icon += 'icon_productapp.bmp';
        break;
      case MDAConstant.Type.ADD_REFERENCEENTITY:
        // 引用实体
        icon += 'icon_ReferenceClass.bmp';
        break;
      case MDAConstant.Type.ADD_SERVICE:
        // 服务
        icon += 'icon_Service.png';
        break;
      case MDAConstant.Type.ADD_SERVICEACTION:
        // 服务操作
        icon += ''; // TODO
        break;
      case MDAConstant.Type.ADD_VALUEOBJECT:
        // 值对象
        icon += 'icon_ValueObject.png';
        break;
      case MDAConstant.Link.ADD_AGGREGATION:
        // 聚合
        icon += 'AggregationTool.png';
        break;
      case MDAConstant.Link.ADD_ASSOCIATION:
        // 关联
        icon += 'AssociationTool.png';
        break;
      case MDAConstant.Link.ADD_COMPOSITION:
        // 组合
        icon += 'CompositeTool.png';
        break;
      case MDAConstant.Link.ADD_CROSS:
        // 交叉关联
        icon += 'CrossTool.png';
        break;
      case MDAConstant.Link.ADD_DEPENDENCY:
        // 依赖
        icon += 'DependencyTool.png';
        break;
      case MDAConstant.Link.ADD_GENERALIZATION:
        // 继承
        icon += 'GeneralizationTool.png';
        break;
      case MDAConstant.Link.ADD_IMPLEMENT:
        // 实现
        icon += 'ImplementTool.png';
        break;
      case MDAConstant.Link.ADD_MENUCONTAIN:
        // 菜单上下级关系
        icon += 'icon_MenuContain.png';
        break;
      case MDAConstant.Link.ADD_TASKSEQUENCE:
        // 任务先后关系
        icon += ''; // TODO
        break;
      default:
        break;
    }
    return icon;
  }
}
